import { DatoIntervalFilterInput } from "../../../interfaces/schema";
import { ExcludeNeverFields } from "../../../interfaces/ts-helpers";

// types for DateFilter component
type DateEventType = "date" | "advanced";

export const DateFilterDateQueries = [
  {
    type: "eq",
    label: "Lig med",
  },
  // {
  //   type: "lte",
  //   label: "Før",
  // },
  // {
  //   type: "gte",
  //   label: "Efter",
  // },
] as const;

export const DateFilterRangeQueries = [
  {
    type: "eq",
    label: "Mellem",
  },
  {
    type: "lte",
    label: "Før",
  },
  {
    type: "gt",
    label: "Efter",
  },
] as const;

type DateFilter = "today" | "date" | "advanced";
type DateSettings = {
  query: (typeof DateFilterDateQueries)[number];
  date: Date;
};
type RangeSetting = {
  query: (typeof DateFilterRangeQueries)[number];
  range: {
    from: Date;
    to: Date;
  };
};
type RangeSettings = {
  start: RangeSetting;
  end: RangeSetting;
};

export type DateFilterSetting = {
  [Filter in DateFilter]: ExcludeNeverFields<{
    filterType: Filter;
    filterSettings: Filter extends "date"
      ? DateSettings
      : Filter extends "advanced"
        ? RangeSettings
        : never;
  }>;
}[DateFilter];

// events
export type DateFilterEvent = {
  [Event in DateEventType]: {
    event: Event;
    filter: DatoIntervalFilterInput;
    settings: DateFilterSetting;
  };
}[DateEventType];

export type DateEvent = {
  query?: (typeof DateFilterDateQueries)[number];
  date?: Date;
};

export type RangeEvent = {
  start?: {
    query?: (typeof DateFilterRangeQueries)[number];
    range?: {
      from?: Date;
      to?: Date;
    };
  };
  end?: {
    query?: (typeof DateFilterRangeQueries)[number];
    range?: {
      from?: Date;
      to?: Date;
    };
  };
};
